module.exports = __webpack_public_path__ + "static/media/Fig-8-6.4affe2e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Fig-8-6.png
// module id = 744
// module chunks = 0